module.exports = require("npm:builtin-status-codes@2.0.0/browser.js");